// @ts-ignore
import fontsCSSContent from '!!raw-loader!@fourthwall/design-system/tokens/fonts.css';
// @ts-ignore
import primitivesCSSContent from '!!raw-loader!@fourthwall/design-system/tokens/primitives.css';
// @ts-ignore
import styleCSSContent from '!!raw-loader!@fourthwall/design-system/tokens/style.css';
import React from 'react';
import { useAppearance } from '@fourthwall/appearance';
import { TinyMCE as TinyMCEComponent } from '@fourthwall/components';
export const TinyMCE = (props) => {
    const { appearance } = useAppearance();
    return (React.createElement(TinyMCEComponent, { tinymceScriptSrc: `${process.env.PUBLIC_PATH}public/tinymce/tinymce.min.js`, appearance: appearance, ...props, contentStyles: `${primitivesCSSContent}${fontsCSSContent}${styleCSSContent}` }));
};
